import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as locations from '../../../../constants/dropdown';
import {messageTextValidation, nameValidation, emailValidation, phoneValidation} from '../../../../utils/itemValidation';

import * as commonActionCreators from '../../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

import RhinoSelect from '../../../common/inputs/RhinoSelect';

class Mothers2021 extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

		const firstEntryNotReq = [{display: 'Location', 'value': ''}];
    const finalEntry = [{display: 'Other', 'value': 'online@diamondsdirect.com'}];
    let newArray= firstEntryNotReq.concat(locations.locations).concat(finalEntry);

		this.state = {
			locations: newArray,
			inputName: '',
			inputEmail: '',
			inputPhone: '',
			inputLocation: '',
			inputMessage: '',
			inputDesigner: '',
			designerLocation: '',
			errorName: null,
			errorEmail: null,
			errorPhone: null,
			errorLocation: null,
			errorMessage: null,
			errorDesigner: null,
			errorDesignerLocation: null,
		};
	}

	internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  changeName(evt) {
		this.setState({ inputName: evt.target.value }, () => {
			if(this.state.errorName && !nameValidation(this.state.inputName)) {
				this.setState({ errorName: null });
			}
		});
	}

	changeEmail(evt) {
		this.setState({ inputEmail: evt.target.value }, () => {
			if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
				this.setState({ errorEmail: null });
			}
		});
	}

	changePhone(evt) {
		this.setState({ inputPhone: evt.target.value }, () => {
			if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
				this.setState({ errorPhone: null });
			}
		});
	}

	changeLocation(evt) {
		this.setState({ inputLocation: evt.target.value}, () => {
			if(this.state.errorLocation !== false && this.state.inputLocation !== '') {
				this.setState({errorLocation: null});
			}
		});
	}

	submitContactRequest() {
		if(this.validateAll()) {

			let contactData = {
				full_name: this.state.inputName,
				email: this.state.inputEmail,
				phone: this.state.inputPhone,
				location: this.state.inputLocation,
			}

			console.log(this.props);
			this.props.commonSummerContactRequest(contactData);
			// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
			this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
			this.setState({
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputDesigner: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
			});
		}
	}

	validateAll() {

    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let emailError = emailValidation(this.state.inputEmail);
    let locationError = nameValidation(this.state.inputLocation);

    // Optional params
    let phoneError = null;
    if(this.state.inputPhone) {
      phoneError = phoneValidation(this.state.inputPhone);
    }

    if(nameError === null &&
       emailError === null &&
       phoneError === null &&
       locationError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorEmail: emailError,
      errorPhone: phoneError,
      errorLocation: locationError,
    }, () => {
    	console.log(this.state);
    });

    return !hasErrors;
  }

	render() {
		return <div className='Mothers2021'>
			<div className="promoBanner">
				<img className='desktop600' src="https://ddw2.diamondsdirect.com/img/promopages/june2021/lander/header_a.jpg" alt="Diamonds Direct" />
				<img className='mobile600' src="https://ddw2.diamondsdirect.com/img/promopages/june2021/lander/header_a_m.jpg" alt="Diamonds Direct" />
			</div>
			<div className='cheersBlock'>
				<div className='cheersBlockWrapper'>
					<div className='cbLeft'>
						<div className='cbLeftWrapper'>
							<div className='cbLeftCopy'>No matter where you are, add a little extra sparkle to your Summer with our Paradise Awaits June Financing Event!</div>
						</div>
					</div>
					<div className='cbRight'>
						<div className='cbRightWrapper'>
							<div className='cbrSuperTitle'>Shop with us and take advantage of:</div>
							<div className='cbrTitle'>0% APR for 5 Years*</div>
							<div className='cbrDisc'>Subject to credit approval.</div>
							<div className='cbrDates'>Available June 1 - July 3</div>
							<div className='cbrButton' onClick={() => this.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826')}>Learn More &amp; Apply</div>
						</div>
					</div>
					<div className={'itemRow cbItems'} style={{marginBottom: '25px'}}>
						<img className='desktop600' src="https://ddw2.diamondsdirect.com/img/promopages/june2021/lander/lander_jewelry.jpg" alt="Diamonds Direct" />
						<img className='mobile600' src="https://ddw2.diamondsdirect.com/img/promopages/june2021/lander/lander_jewelry_m.jpg" alt="Diamonds Direct" />
						<div className={'cbiLink cbiTopLeft'} onClick={() => this.internalNav('setting/SMD1445393')}></div>
						<div className={'cbiLink cbiTopRight'} onClick={() => this.internalNav('setting/SMDTT02867')}></div>
						<div className={'cbiLink cbiBottomLeft'} onClick={() => this.internalNav('jewelry/BLDXL15035')}></div>
						<div className={'cbiLink cbiRight'} onClick={() => this.internalNav('setting/SMD1444401')}></div>
					</div>
				</div>
			</div>			
			<div className='formBoxWrapper'>
				<div className='formInnerWrapper'>
					
					<div className='formP'>Walk-in visits are always welcome! But if you’d prefer to set up an appointment online or in store, please use the form below and we will follow up to confirm!</div>

					<div className='formWrapper'>
						<div className='formInputWrapper'>
							<input 
								className={this.state.errorName ? 'textInput error' : 'textInput'}
								type='text' 
								placeholder='Full Name*'
								value={this.state.inputName}
              					onChange={::this.changeName} />
						</div>
						<div className='formInputWrapper'>
							<input 
								className={this.state.errorEmail ? 'textInput error' : 'textInput'}
								type='email' 
								placeholder='Email Address*'
								value={this.state.inputEmail}
              					onChange={::this.changeEmail} />
						</div>
						<div className='formInputWrapper'>
							<input 
								className={this.state.errorPhone ? 'textInput error' : 'textInput'}
								type='text' 
								placeholder='Telephone'
								value={this.state.inputPhone}
              					onChange={::this.changePhone} />
						</div>
						<div className='formInputWrapper'>
							<RhinoSelect
				                selectClass={'summerSelect'}
				                required={true}
				                value={this.state.inputLocation}
				                options={this.state.locations}
				                changeMethod={(evt) => this.changeLocation(evt)}
				                error={this.state.errorLocation !== null} />
						</div>
						<div className='formActionRow'>
							<button className={'formAction'} onClick={::this.submitContactRequest}>Request an appointment</button>
						</div>
					</div>
				</div>
			</div>
			<div className='blockSection'>
				<div className='blockSectionWrapper'>
					<div className={'blockItem fianceBlock'}>
						<div className='mainRow'>
							<div className={'mrBlock imgBlock'}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/fiancees.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
							<div className={'mrBlock copyBlock rightCopy'}>
								<div className='mrBlockWrapper'>
									<div className='mrbTitle'>CHEERS TO THE FIANCEES</div>
									<div className='mrbCopy'>To the ones who are ready to open a new chapter.</div>
									<div className='mrbButton' onClick={() => this.openNew('https://gifts.diamondsdirect.com/summer')}>Shop Summer Weddings</div>
								</div>
							</div>
						</div>
						<div className='itemRow'>
							<div className={'itemBlock'} onClick={() => this.internalNav('band/B147M01806')}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/B147M01806.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
							<div className={'itemBlock'} onClick={() => this.internalNav('setting/SMD1444401')}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/SMD1444401.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
							<div className={'itemBlock'} onClick={() => this.internalNav('band/BLDSM22659')}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/BLDSM22659.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
							<div className={'itemBlock'} onClick={() => this.internalNav('setting/SMD1439174')}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/wedding4.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
						</div>
					</div>
					<div className={'blockItem newlywedBlock'}>
						<div className='mainRow'>
							<div className={'mrBlock imgBlock mobileMakeup'}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/newlyweds.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
							<div className={'mrBlock copyBlock'}>
								<div className='mrBlockWrapper'>
									<div className='mrbTitle'>CHEERS TO THE NEWLYWEDS</div>
									<div className='mrbCopy'>To the ones whose love endured through it all.</div>
									<div className='mrbButton' onClick={() => this.openNew('https://gifts.diamondsdirect.com/anniversary')}>Shop Anniversary Gifts</div>
								</div>
							</div>
							<div className={'mrBlock imgBlock rightImg'}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/newlyweds.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
						</div>
						<div className='itemRow'>
							<div className={'itemBlock doubleItem'} onClick={() => this.internalNav('jewelry/BLDXL05912')}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/anniversary2.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
							<div className={'itemBlock'} onClick={() => this.internalNav('diamond-studs')}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/ddrhe.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
							<div className={'itemBlock'} onClick={() => this.internalNav('diamond-pendants')}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/ddrhp.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
						</div>
					</div>
					<div className={'blockItem gradBlock'}>
						<div className='mainRow'>
							<div className={'mrBlock imgBlock'}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/grads.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
							<div className={'mrBlock copyBlock rightCopy'}>
								<div className='mrBlockWrapper'>
									<div className='mrbTitle'>CHEERS TO THE GRADUATES</div>
									<div className='mrbCopy'>To the ones who worked so hard to succeed.</div>
									<div className='mrbButton' onClick={() => this.openNew('https://gifts.diamondsdirect.com/under-1k')}>Shop Gifts Under $1000</div>
								</div>
							</div>
						</div>
					</div>
					<div className={'blockItem dadBlock'}>
						<div className='mainRow'>
							<div className={'mrBlock imgBlock mobileMakeup'}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/dads.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
							<div className={'mrBlock copyBlock'}>
								<div className='mrBlockWrapper'>
									<div className='mrbTitle'>CHEERS TO THE DADS</div>
									<div className='mrbCopy'>To the ones who you can always count on.</div>
									<div className='mrbButton' onClick={() => this.openNew('https://gifts.diamondsdirect.com/watches')}>Shop Watches</div>
								</div>
							</div>
							<div className={'mrBlock imgBlock rightImg'}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/dads.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
						</div>
						<div className='itemRow'>
							<div className={'itemBlock'} onClick={() => this.openNew('https://ecjluxenc.com/collections/hublot/products/big-bang-steel-ceramic')}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/bb_steel_ceramic.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
							<div className={'itemBlock'} onClick={() => this.openNew('https://ecjluxenc.com/collections/blancpain/products/fifty-fathoms-bathyscaphe-10')}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/ff_bathyscaphe.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
							<div className={'itemBlock'} onClick={() => this.openNew('https://ecjluxenc.com/collections/blancpain/products/fifty-fathoms-automatique-titanium-on-blue-sail-canvas')}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/FF_automatique.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
							<div className={'itemBlock'} onClick={() => this.openNew('https://ecjluxenc.com/collections/maurice-lacroix/products/copy-of-aikon-automatic-42mm-anthracite')}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/mothers2021/landing/assets/aikon.jpg" alt="Diamonds Direct Mothers Day" />
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>;
	}
}
export default Mothers2021;

function mapStateToProps(state) {
  return {

  };
}

export const Mothers2021Container = connect(
  mapStateToProps,
  allActionCreators
)(Mothers2021);


// WEBPACK FOOTER //
// ./src/components/views/promopages/mothers2021/Mothers2021.jsx